import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import request from '../../helpers/request';
import itemConfig from '../items/config/itemConfig';
import { Select, AdornedInput, Input } from '../common/Forms';

var WithdrawalReceiptLine = createReactClass({
  propTypes: {
    index: PropTypes.number.isRequired
  },

  getInitialState() {
    return {
      storageLocations: [],
      selectedStorageLocationId: null,
      stockUnitQuantity: 0
    };
  },

  componentDidMount() {
    request.get({
      url: itemConfig.apiUrl + this.props.item.id + '/storagelocations',
      success: locations => {
        this.setState({
          storageLocations: locations,
          selectedStorageLocationId: this.props.item.defaultStorageLocationId
        });
      }
    });
  },

  onStorageLocationSelect(storageLocationId) {
    this.setState({
      selectedStorageLocationId: storageLocationId
    });
  },

  getSelectedStorageLocation() {
    if(!this.state.storageLocations){
      return null;
    }

    var storageLocation = this.state.storageLocations
      .find(x => x.storageLocationId === this.state.selectedStorageLocationId);

    return storageLocation;
  },

  render() {
    const {index} = this.props;
    var storageLocation = this.getSelectedStorageLocation();

    var storageLocationOptions = this.state.storageLocations.map(l =>
      ({ value: l.storageLocationId, label: l.storageLocationName })
    );

    return (
      <tr>
        <td>{this.props.item.name}</td>
        <td>
          <Input name={`lines[${index}].itemId`} type="hidden" required value={this.props.item.id} />

          <Select
            layout="elementOnly"
            name={`lines[${index}].storageLocationId`}
            id={`lines[${index}].storageLocationId`}
            options={storageLocationOptions}
            value={this.state.selectedStorageLocationId}
            onChange={(name, storageLocationId) => this.onStorageLocationSelect(storageLocationId)}
            required
          />
        </td>
        <td>
          {storageLocation ? storageLocation.stockUnitQuantity : ''}
        </td>
        <td>
          <AdornedInput
            layout="elementOnly"
            name={`lines[${index}].stockUnitQuantity`}
            id={`lines[${index}].stockUnitQuantity`}
            type="number"
            value={this.state.stockUnitQuantity}
            validations={{
              isMoreThan: 0,
              isInt: true,
              isLessThan: storageLocation ? (storageLocation.stockUnitQuantity + 1) : 0
            }}
            required
          />
        </td>
        <td>{storageLocation ? storageLocation.stockUnitName : ''}</td>
        <td>
            <a className="btn-sm btn-danger" onClick={() => this.props.onRemove(index)}><i className="fa fa-remove"></i> </a>
        </td>
      </tr>
    );
  }

});

export default WithdrawalReceiptLine;



// WEBPACK FOOTER //
// ./src/components/withdrawalreceipts/WithdrawalReceiptLine.js